module.exports = __webpack_public_path__ + "img/122.069080df.png";